import { Component, ChangeDetectionStrategy, signal, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { IAuditEvent } from 'src/app/core/models/audit-event';

@Component({
  selector: 'app-audit-detail',
  standalone: true,
  imports: [CommonModule, ButtonsModule],
  templateUrl: './audit-detail.component.html',
  styleUrl: './audit-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuditDetailComponent {
  public event = signal<IAuditEvent | null>(null);
  public close = output<void>();

  // Expose Object.keys for template use
  protected readonly Object = Object;

  public onClose(): void {
    this.close.emit();
  }

  public getDiffEntries(): { field: string; old: any; new: any }[] {
    const evt = this.event();
    if (!evt?.diff_json) return [];
    return Object.entries(evt.diff_json).map(([field, values]) => ({
      field,
      old: values.old,
      new: values.new,
    }));
  }

  public formatValue(value: any): string {
    if (value === null || value === undefined) return '—';
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    if (Array.isArray(value)) return value.join(', ');
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
  }
}
